export default __webpack_public_path__ + "static/media/received_238373995180779.8cb059ec.jpg";